<template>
  <div class="container">
    <table class="table-v table table-striped table-hover">
      <thead>
        <tr>
          <th>
            路线分类
          </th>
          <th>
            路线简称
          </th>
          <th>
            路线标题
          </th>
          <th>
            操作
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" track-by="$index">
          <td>
            【{{item.catalog}}】
          </td>
          <td class="text-primary">
            {{item.abbreviation}}
          </td>
          <td>
            {{item.title}}
          </td>
          <td>
            <div class="btn-group btn-group-sm btn-group" role="group" aria-label="Default button group">
              <button @click="click(restore)($event, item.id)" type="button" class="btn btn-default">恢复</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import config from '../../libs/config'
  import utils from '../../libs/utils'

  export default {
    data () {
      return {
        list: []
      }
    },
    methods: {
      queryList () {
        return this.$http.get(config.apiWe + '/product/route?trashed=yes')
          .then(({data}) => {
            this.$set('list', data['list'])
          })
      },
      restore (routeId) {
        return this.$http.put(`${config.apiWe}/product/route/${routeId}/restore`)
          .then(this.queryList)
      },
      click: utils.click
    },
    route: {
      data ({next}) {
        return this.queryList()
      }
    }
  }
</script>

<style scoped>
  .table-v td {
    vertical-align: middle;
  }
</style>



/** WEBPACK FOOTER **
 ** Trashed.vue?062dc641
 **/